import { isNull, sql } from "@-/com.npmjs.drizzle-orm";
import type {
  ActorDatabaseHandle,
  ActorTransaction,
} from "@-/dev.improve.haniverse.database.actor";
import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";

/**
 * The learner's XP, derived from the quest ledger rather than stored: the sum of every live
 * quest's `xpEarned`, which is 0 until the quest is completed. Quests are the only source of XP; reviews earn Han, not XP.
 *
 * `select` does not filter soft-deleted rows the way `query.*` does, so the read filters them.
 */
export async function readXp(db: ActorDatabaseHandle | ActorTransaction): Promise<number> {
  const [row] = await db
    .select({ xp: sql<number>`coalesce(sum(${actorSchema.userQuest.xpEarned}), 0)` })
    .from(actorSchema.userQuest)
    .where(isNull(actorSchema.userQuest.deletedAt));
  return Number(row?.xp ?? 0);
}
